<mat-dialog-content>
  <mat-accordion>
    <mat-expansion-panel>
      <mat-expansion-panel-header>
        <mat-panel-title>Comment fonctionne l'outil ?</mat-panel-title>
      </mat-expansion-panel-header>
      <p class="mb-4">
        Tout se passe au sein d'une "session d'eligibilité". Une <b>session</b> permet de regrouper un ensemble de sites,
        potentiellement issus de plusieurs clients.
      </p>

      <p class="mb-4">
        L'écran d'accueil de l'outil liste les sessions de l'utilisateur :
      </p>

      <img src="/assets/faq/image-0.png" class="mb-4">

      <p class="mb-4">
        Vous avez la possibilité de créer une nouvelle session en cliquant sur le bouton "Créer une nouvelle session"
        (1) et en précisant un nom pour cette nouvelle session :
      </p>

      <img src="/assets/faq/image-1.png" class="mb-4">

      <p class="mb-4">
        Lors de la création, chaque session se voit attribuer un <b>code</b> unique (exemple : 6HDUJ) - ce code peut être
        partagé avec vos collègues pour vous permettre de travailler à plusieurs sur une même session en simultané. Vous
        avez la possibilité via cet écran d'ouvrir une session via son code via le champ "Ouvrir une session existante"
        (2)
      </p>

      <p class="mb-4">
        Vous avez également la possibilité de :
      </p>

      <ul class="list-disc pl-6 mb-4">
        <li>
          <b>Ouvrir</b> une session existante, en cliquant sur le bouton (3) ou en effectuant un double-clic sur la
          ligne de la session souhaitée
        </li>

        <li>
          <b>Modifier le nom</b> d'une session existante en cliquant sur le bouton (4)
        </li>

        <li><b>Dupliquer</b> une session existante en cliquant sur le bouton (5)</li>

        <li>
          <b>Archiver</b> une session existante en cliquant sur le bouton (6).
          Lorsqu'une session est archivée, elle n'est visible que si l'on coche "Afficher les sessions archivées" (7). Pour la désarchiver, il suffit de cliquer sur le bouton (6) à nouveau.
        </li>

        <li>
          <b>Supprimer</b> une session existante en cliquant sur le bouton (8)
        </li>
      </ul>

      <p class="mb-4">
        Lorsqu'une session est ouverte, l'entête de page présente les fonctionnalités suivantes :
      </p>

      <img src="/assets/faq/image-3.png" class="mb-4">

      <ul class="list-disc pl-6">
        <li>
          <b>Revenir à l'écran d'accueil</b> de l'outil, listant les sessions, en cliquant sur le logo (1)
        </li>

        <li>
          <b>Renommer</b> la session en cours, en cliquant sur le bouton (2)
        </li>

        <li>
          <b>Dupliquer</b> la session en cours en cliquant sur le bouton (3), cela ouvrira ensuite automatiquement la nouvelle session dupliquée
        </li>

        <li>
          <b>Partager</b> la session en cours avec des collaborateurs en cliquant sur le bouton (4), le lien de partage sera copié dans le presse-papier et peut être collé dans un chat. 
          Toute personne disposant de ce lien pourra accéder à la session et y apporter des modifications, mais ne pourra pas la supprimer.
        </li>

        <li>
          <b>Accéder à l'onglet "Fiabilisation"</b> en cliquant sur le bouton (5), qui permet d'importer et fiabiliser des sites pour une session. Il s'agit de l'onglet sélectionné par défaut en arrivant sur une session. Plus de détails sont disponibles dans la section "Comment fonctionne l'onglet "Fiabilisation" ?".
        </li>

        <li>
          <b>Accéder à l'onglet "Éligibilité"</b> en cliquant sur le bouton (6), qui permet de lancer une éligibilité technique sur les sites importés et fiabilisés au préalable en sélectionnant les opérateurs et technologies souhaitées. Plus de détails sont disponibles dans la section "Comment fonctionne l'onglet "Éligibilité" ?".
        </li>
      </ul>

    </mat-expansion-panel>
  
    <mat-expansion-panel>
      <mat-expansion-panel-header>Comment fonctionne l'onglet "Fiabilisation" ?</mat-expansion-panel-header>
        <p class="mb-4">
          L'onglet "Fiabilisation" permet d'importer et fiabiliser des sites pour une session. Il est composé de deux
          sous-écrans : la <b>liste des sites</b> (1) et la <b>carte</b> (4). 
        </p>
        <p class="mb-4">
          Le but de cet onglet est que l'utilisateur <b>importe des sites</b> (voir "Comment importer des sites ?"), 
          ce qui lancera ensuite une <b>fiabilisation automatique</b> (voir "Comment fonctionne la fiabilisation automatique des sites ?"), 
          puis qu'il vérifie les sites marqués incertain ou introuvable par l'algorithme de fiabilisation en effectuant une <b>fiabilisation manuelle</b> 
          (voir "Comment fiabiliser manuellement un site ?").
        </p>

        <img src="/assets/faq/fiab-0.png" class="mb-4">

        <p class="mb-4">
          La liste des sites (1) est le tableau affiché sur le côté gauche de l'écran. 
          Il permet de consulter les informations des sites importés et est accompagné de fonctions de tri et de recherche sur les champs pertinents.</p>
        <p class="mb-4">
          Entre les deux sous-écrans, vous avez une barre de séparation (2) qui permet d'ajuster la taille de la carte et de la liste des sites en la faisant glisser horizontalement. 
          En cliquant sur le bouton (3), vous pouvez rétracter complètement la carte. Pour la faire réapparaître, cliquez à nouveau dessus.
        </p>
        <p class="mb-4">
          La carte (4) est affichée sur le côté droit de l'écran. 
          Elle permet de visualiser les sites importés via un marqueur de site placé sur la carte et d'en réaliser la fiabilisation manuelle. 
          Il n'est possible de fiabiliser manuellement que les sites ayant déjà fait l'objet d'une fiabilisation automatique
        </p>

        
        <p class="mb-4">
          Une fois des sites importés, vous avez maintenant accès à différentes informations et fonctionnalités :
        </p>
        <img src="/assets/faq/fiab-1.png" class="mb-4">

        <ul class="list-disc pl-6">
          <li>
            La première colonne (1) permet de <b>sélectionner un ou plusieurs sites</b> pour effectuer des actions sur ces sites. Ces cases ne servent PAS à zoomer sur un site sur la carte, pour cela il faut cliquer ailleurs sur la ligne correspondante. 
          </li>

          <li>
            Dans la catégorie <b>Infos site</b> (2), vous pouvez visualiser les informations du site sélectionné. Par défaut, seulement le nom du site sera affiché. Plus d'informations dans cette catégorie sont disponibles en cliquant sur la flèche à droite de "Infos site" (3) : ID site, Référence site.
          </li>
  
          <li>
            Dans la catégorie <b>Données source</b> (4), vous pouvez visualiser les données fournies en entrée. Par défaut, seulement l'adresse complète sera affichée. Plus d'informations dans cette catégorie sont disponibles en cliquant sur la flèche à droite de "Données source" (5) : Adresse, Code postal, Commune, Coordonnées GPS, Code Immeuble.
          </li>
  
          <li>
            Dans la catégorie <b>Données fiabilisées</b> (6), vous pouvez visualiser les données à l'issue de la fiabilisation. Par défaut, seulement l'adresse complète sera affichée. Plus d'informations dans cette catégorie sont disponibles en cliquant sur la flèche à droite de "Données fiabilisées" (7) : Adresse, Code postal, Commune, Coordonnées GPS, Code Immeuble.
          </li>
  
          <li>
            Dans la colonne <b>État</b> (8), vous pouvez consulter l'état de fiablisation des sites. En cliquant sur l'icône correspondante au statut (9), une fenêtre de dialogue s'ouvre, avec plus de détails sur les différentes étapes de la fiabilisation pour ce site.
          </li>
  
          <li>
            Dans la colonne <b>Vérif.</b> (10), vous pouvez consulter l'état de vérification des sites. Si le site a été fiabilisé manuellement, vous pouvez passer la souris sur l'icône pour savoir qui a effectué la fiabilisation et quand (11).
          </li>
        </ul>

        <img src="/assets/faq/fiab-2.png" class="mb-4">

        <p class="mb-4">
          Lorsque vous sélectionnez un ou plusieurs sites, vous pouvez effectuer des actions sur ces sites :
        </p>

        <ul class="list-disc pl-6">
          <li>
            <b>Exporter les sites sélectionnés</b> via le bouton (1). Si aucun site n'est sélectionné, l'export sera effectué pour tous les sites de la session. Le résultat sera un fichier Excel exhaustif listant toutes les informations disponibles pour un site :
            Infos générales du site, Données source, Données fiabilisées, État de fiabilisation, Type de fiabilisation, Méthode de fiabilisation, Opérateur d'infrastructure, État d'éligibilité technique, Résultats d'éligibilité technique.
          </li>

          <li>
            <b>Relancer la fiabilisation automatique</b> des sites sélectionnés via le bouton (2). C'est principalement utile si vous avez modifié les données source d'un site ou si la fiabilisation automatique semble bloquée depuis longtemps.
            Attention, vous perdrez les changements apportés par la fiabilisation manuelle si vous relancez la fiabilisation automatique sur ce site.
          </li>

          <li>
            <b>Supprimer les sites sélectionnés</b> via le bouton (3). Cette action est irréversible et supprimera définitivement les sites de la session.
          </li>
        </ul>

    </mat-expansion-panel>

    <mat-expansion-panel>
      <mat-expansion-panel-header>
        <mat-panel-title>Comment fonctionne l'import des sites ? </mat-panel-title>
      </mat-expansion-panel-header>
      <p class="mb-4">Vous pouvez importer des sites de plusieurs façons. Commencez par cliquer sur le bouton "Importer" (1) depuis une session ouverte :
      </p>

      <img src="/assets/faq/image-4.png" class="mb-4">

      <p class="mb-4 font-bold">Depuis un client existant (2)</p>

      <p class="mb-4">
        Vous pouvez retrouver et importer les sites d'un client déjà connu et renseigné dans le SI adista
      </p>

      <img src="/assets/faq/image-6.png" class="mb-4">

      <p class="mb-4">
        Saisissez la raison sociale, SIREN ou SIRET dans le champ (1), appuyez sur entrée ou cliquez sur le bouton (2)
        pour effectuer la recherche. Une liste de clients s'affiche ensuite. Sur la ligne du client souhaité, effectuez
        un double-clic ou cliquez sur le bouton "Sélectionner" pour accéder aux sites enregistrés pour ce client (3)
      </p>

      <img src="/assets/faq/image-7.png" class="mb-4">

      <p class="mb-4">
        Sélectionnez ensuite un ou plusieurs sites en cliquant sur les lignes des sites souhaités, ou en cochant /
        décochant la checkbox dans la colonne (1).
      </p>

      <p class="mb-4">
        Une fois tous les sites sélectionnés, cliquez sur le bouton "Importer X sites" (2)
      </p>

      <p class="mb-4 font-bold">Depuis un fichier CSV / XLSX (3)</p>

      <img src="/assets/faq/image-8.png" class="mb-4">

      <p class="mb-4">
        Cliquez sur le bouton (1) et sélectionnez un fichier CSV / XLSX. Le contenu du fichier s'affiche dans le
        tableau.
      </p>

      <p class="mb-4">
        Si le fichier sélectionné ne contient aucune ligne d'entête, vous pouvez décocher la case "Avec entête" (2).
      </p>

      <p class="mb-4">
        Vous devez indiquer le type de données contenu dans les différentes colonnes via la liste déroulante proposée en
        entête de chaque colonne (4)
      </p>

      <p class="mb-4">
        Vous pouvez sélectionner / désélectionner des sites avec la checkbox dans la première colonne (3)
      </p>

      <p class="mb-4">
        Pour importer les sites sélectionnés dans la session, cliquez sur le bouton "Importer X sites" (5)
      </p>

      <img src="/assets/faq/image-9.png" class="mb-4">
    </mat-expansion-panel>

    <mat-expansion-panel>
      <mat-expansion-panel-header>
        <mat-panel-title>Comment fonctionne la fiabilisation automatique des sites ?</mat-panel-title>
      </mat-expansion-panel-header>

      <p class="mb-4">
        Lors de l'import des sites, les données fournies en entrée sont normalisées puis traitées par notre algorithme
        de fiabilisation automatique
      </p>

      <p class="mb-4">Nous faisons appel à plusieurs services, par ordre de priorité :</p>

      <ul class="list-disc pl-6 mb-4">
        <li>
          Si un code immeuble est fourni en entrée, nous faisons appel à "address-normalizer", permettant de retrouver
          une adresse / des coordonnées à partir d'un code immeuble ARCEP.
        </li>
        <li>
          Base Adresse FTTH : permet de retrouver un code immeuble ARCEP à partir d'une adresse ou de coordonnées. L'algorithme priorise d'abord l'adresse puis les coordonnées.
        </li>
        <li>
          Base Adresse Nationale : permet de retrouver des coordonnées à partir d'une adresse et inversement, sans code
          immeuble ARCEP. L'algorithme priorise d'abord l'adresse puis les coordonnées.
        </li>
      </ul>

      <p class="mb-4">
        Si plusieurs informations sont fournies, par exemple un code immeuble et une adresse, un controle de coherence
        est effectué : si l'adresse fournie ne correspond pas à l'adresse liée au code immeuble dans la base ARCEP,
        alors l'état de fiabilisation du site sera indiqué comme "Incertain". Même fonctionnement avec les coordonnées.
      </p>

      <p class="mb-4">
        Ces services renvoient en general un "score", 100% étant une correspondance exacte. Le résultat d'un service est
        retenu si le score est supérieur ou égal à 80%.
      </p>

      <p class="mb-4">
        Temps de traitement : La fiabilisation de 500 sites nécessite, en général, moins de 10 minutes. Les résultats se
        mettent à jour en temps réel dans l'outil et une barre de progression s'affiche en haut de l'écran, montrant la
        repartition des états de fiabilisation. Cette barre de progression s'affiche également à l'étape suivante, la
        fiabilisation manuelle.
      </p>

      <p class="mb-4">Trois états de fiabilisation possibles :</p>

      <ul class="list-disc pl-6 mb-4">
        <li>Fiabilisé</li>
        <li>Incertain</li>
        <li>Introuvable</li>
      </ul>

      <p class="mb-4">
        Suite à cette étape, certains sites de la session peuvent s'afficher en rouge, c'est le cas lorsqu'aucun
        résultat viable n'a été trouvé pour situer le site sur la carte. Il faudra corriger l'adresse et relancer
        la fiabilisation manuellement, ou supprimer le site, avant de pouvoir passer à l'étape suivante.
      </p>

      <p class="mb-4 font-bold">Que signifie "Incertain - Score faible" ?</p>

      <p class="mb-4">
        L'algorithme de fiabilisation a trouvé un résultat proche, mais pas assez proche pour en être sûr. Actuellement
        cela correspond à un score inferieur ou égal à 80%.
      </p>

      <p class="mb-4 font-bold">Que signifie "Incertain - Incoherence coordonnées" ?</p>

      <p class="mb-4">
        Des coordonnées ont été fournies en entrée, mais celles-ci ne correspondent pas avec les coordonnées trouvées
        par l'algorithme de fiabilisation automatique. Actuellement cela correspond à un écart de plus de 50 mètres
        entre les deux points.
      </p>

      <p class="mb-4 font-bold">Que signifie "Incertain - Incoherence adresse" ?</p>

      <p class="mb-4">
        Une adresse a été fournie en entrée, mais celle-ci ne correspond pas tout à fait avec celle trouvée par
        l'algorithme de fiabilisation automatique. C'est le cas par exemple lorsque le numéro de rue, le nom de la rue,
        le code postal ou la commune sont différents.
      </p>
    </mat-expansion-panel>

    <mat-expansion-panel>
      <mat-expansion-panel-header>
        <mat-panel-title>Comment fonctionne la fiabilisation manuelle des sites ?</mat-panel-title>
      </mat-expansion-panel-header>
      <p class="mb-4">Voici les fonctionnalités de base de la carte de l'onglet "Fiabilisation" : </p>

      <img src="/assets/faq/fiab-3.png" class="mb-4">

      <p class="mb-4">
        Vous pouvez zoomer sur la carte avec la molette de la souris, ou en cliquant sur les boutons "+" et "-" (1) en
        haut à gauche de la carte.
      </p>

      <p class="mb-4">
        Vous avez la possibilité de modifier le fond de carte via le bouton en haut à droite (2) pour faciliter la
        localisation des sites.
      </p>

      <p class="mb-4">
        Il est possible de cliquer sur un marqueur de site (3) pour zoomer sur un site.
      </p>

      <img src="/assets/faq/fiab-4.png" class="mb-4">

      <p class="mb-4">
        Il est également possible de zoomer sur un site en cliquant sur la ligne correspondante dans la liste des sites (1). 
        Après avoir zoomé sur un site, les codes immeuble ARCEP à proximité sont affichés sur la carte (2). La couleur du code immeuble indique l'état de déploiement.
        Vous pouvez cliquer sur un code immeuble (2) pour déplacer le marqueur du site concerné sur cet immeuble et fiabiliser le site directement.
      </p>

      <p class="mb-4">
        Vous pouvez repositionner un marqueur de site directement en entrant de nouvelles coordonnées GPS dans le champ prévu à cet effet (3). Le marqueur se déplacera automatiquement sur la carte et le site sera repositionné sur ce point.
      </p>

      <p class="mb-4">
        Vous avez la possibilité de déplacer le marqueur en dehors d'un code immeuble en cliquant dessus et en le faisant glisser sur la carte. Une fois le marqueur correctement positionné, vous pouvez modifier l'état de
        fiabilisation avec les boutons en bas (4). En changeant d'état, l'outil passe directement au site suivant.
      </p>

      <p class="mb-4">
        Il est également possible de passer au site suivant ou precedent avec les flèches du clavier. Si vous souhaitez
        désélectionner le site actuellement sélectionné, appuyez sur la touche "Echap" du clavier.
      </p>
    </mat-expansion-panel>

    <mat-expansion-panel>
      <mat-expansion-panel-header>
        <mat-panel-title>Comment fonctionne l'onglet "Éligibilité" ?</mat-panel-title>
      </mat-expansion-panel-header>

      <p class="mb-4">
        L'onglet "Éligibilité" permet de lancer une éligibilité technique sur les sites importés et fiabilisés au préalable, avec
        la possibilité de sélectionner les opérateurs et technologies souhaitées.
      </p>

      <img src="/assets/faq/elig-0.png" class="mb-4">

      <p class="mb-4">
        Pour lancer l'éligibilité technique, vous devez d'abord sélectionner les sites à tester dans le tableau et cliquer sur le bouton "Lancer l'éligibilité" (2). 
        Vous pouvez sélectionner tous les sites en cliquant sur la case dans l'entête du tableau. Si aucun site n'est sélectionné, l'éligibilité sera lancée sur tous les sites dans un statut permettant l'éligibilité technique (Fiabilisé ou Incertain).
        Une fenêtre de dialogue s'ouvre ensuite pour vous permettre de sélectionner les opérateurs et technologies à tester.
      </p>

      <img src="/assets/faq/elig-1.png" class="mb-4">

      <p class="mb-4">
        Vous pouvez sélectionner un ou plusieurs opérateurs et technologies à tester via les listes déroulantes correspondantes.
        Par défaut, l'éligibilité ne sera pas rejouée pour les sites qui en ont déjà fait l'objet <b>parmi</b> les sites sélectionnés. 
        Pour la relancer tout de même, cochez la case "Relancer l'éligibilité pour tous les sites" avant de cliquer sur le bouton "Lancer"
      </p>

      <img src="/assets/faq/elig-0.png" class="mb-4">

      <p class="mb-4">
        Une fois l'éligibilité technique lancée, vous pouvez suivre l'avancement du traitement en temps réel dans le tableau.
        L'état d'éligibilité technique est indiqué dans le groupe de colonnes "Fibre" (3).
      </p>

      <p class="mb-4">
        Une fois obtenus, vous pourrez consulter le détail des résultats d'éligibilité technique pour un site en cliquant sur l'icône correspondante dans le tableau (4). 
        Une fenêtre de dialogue s'ouvre avec le détail par opérateur et par technologie.
      </p>

      <img src="/assets/faq/elig-2.png" class="mb-4">

      <p class="mb-4">À noter:</p>

      <p class="mb-4">
        Les demandes d'eligibilité technique en masse sont considérées comme moins prioritaires par rapport aux demandes
        d'eligibilité technique unitaires réalisés via d'autres outils.
      </p>

      <p class="mb-4">Les éligibilités techniques lancées depuis l'outil MassEligibility sont lancées toutes les 5 minutes. Le
        traitement se fait par lot de 100 sites. Le lot suivant sera lancé 5 minutes plus tard.
      </p>

      <p class="mb-4">
        Une éligibilité technique sur 1 000 sites peut de cette façon nécessiter environ une heure, en fonction de la
        charge du moteur d'eligibilité technique.
      </p>
    </mat-expansion-panel>

    <mat-expansion-panel >
      <mat-expansion-panel-header>
        <mat-panel-title>Eligibilité technique: Quels opérateurs sont supportés ?</mat-panel-title>
      </mat-expansion-panel-header>

      <ul class="list-disc pl-6 mb-4">
        <li>
          Cuivre
          <ul class="list-disc pl-6">
            <li>ADSL / SDSL</li>
            <ul class="list-disc pl-6">
              <li>Bouygues Télécom</li>
              <li>Kosc</li>
              <li>Orange</li>
            </ul>
          </ul>
        </li>

        <li>
          Fibre
          <ul class="list-disc pl-6">
            <li>FTTH</li>
            <ul class="list-disc pl-6">
              <li>Bouygues Télécom</li>
              <li>Orange</li>
              <li>SFR</li>
              <li>Axione</li>
              <li>Free</li>
              <li>Kosc</li>
            </ul>

            <li>FTTO</li>
            <ul class="list-disc pl-6">
              <li>Bouygues Télécom</li>
              <li>Eurofiber</li>
              <li>Orange</li>
              <li>SFR</li>
              <li>Axione</li>
              <li>Ielo</li>
              <li>Covage</li>
            </ul>

            <li>FTTE</li>
            <ul class="list-disc pl-6">
              <li>Bouygues Télécom</li>
              <li>Orange</li>
              <li>Kosc</li>
              <li>Covage</li>
            </ul>
          </ul>
        </li>
      </ul>
    </mat-expansion-panel>

    <mat-expansion-panel >
      <mat-expansion-panel-header>
        <mat-panel-title>Est-ce qu'il y a des limites ?</mat-panel-title>
      </mat-expansion-panel-header>
      <ul class="list-disc pl-6 mb-4">
        <li>Nombre de sites : pour l'instant l'outil permet d'accueillir au maximum 1000 sites au sein d'une session d'eligibilité.</li>
      </ul>
    </mat-expansion-panel>

    <mat-expansion-panel >
      <mat-expansion-panel-header>
        <mat-panel-title>Qui contacter en cas de problème ?</mat-panel-title>
      </mat-expansion-panel-header>

      <p class="mb-4">Vous pouvez envoyer un email à
        <a href="mailto:Lst_DIT_Tribe_Lab_VD@adista.fr" class="text-blue-600 underline">Lst_DIT_Tribe_Lab_VD@adista.fr</a> en fournissant :
      </p>

      <ul class="list-disc pl-6 mb-4">
        <li>L'URL de la page concernée</li>
        <li>Le type et la version du navigateur utilisé</li>
        <li>Une capture d'écran</li>
        <li>Tout fichier utile (exemple: fichier CSV/XLSX en cas de problème d'import)</li>
      </ul>

    </mat-expansion-panel>
  </mat-accordion>
</mat-dialog-content>